import api from 'api/api'
import { toast } from 'react-toastify'
import { urlPdfs } from 'constants/urls'
import { ORDER_STATUS } from 'constants/orders'

export const GET_ORDERS = '[ORDERS] GET ORDERS'
export const GET_ORDER_BY_ID = '[ORDERS] GET ORDER BY ID'
export const RESET_ORDER_BY_ID = '[ORDERS] RESET ORDER BY ID'
export const SAVE_ORDER = '[ORDERS] SAVE ORDER'
export const FINISH_ORDER_REGISTER = '[ORDERS] FINISH ORDER REGISTER'
export const FINISH_ORDER_WITH_SERIES = '[ORDERS] FINISH ORDER WITH SERIES'
export const VOID_ORDER = '[ORDERS] VOID ORDER'
export const SAVE_ORDER_FROM_PROFORMA = '[ORDERS] SAVE ORDER FROM PROFORMA'

export function getOrdersAction(filters = { skipUserId: 0, startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/orders/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_ORDERS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ORDERS, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_ORDERS, error)
    }).finally(() => {
      dispatch({ type: GET_ORDERS, payload: { loading: false } })
    })
  }
}

export function getOrderByIdAction(orderId) {
  const request = api.get(`/order/${orderId}`)
  return (dispatch) => {
    dispatch({ type: GET_ORDER_BY_ID, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_ORDER_BY_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_ORDER_BY_ID, error)
    }).finally(() => {
      dispatch({ type: GET_ORDER_BY_ID, payload: { loading: false } })
    })
  }
}

export function saveOrderAction(data) {
  const request = api.post(`/order/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_ORDER, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_ORDER, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_ORDER, error)
    }).finally(() => {
      dispatch({ type: SAVE_ORDER, payload: { saving: false } })
    })
  }
}

export function finishOrderRegisterAction(orderId) {
  const request = api.post(`/order/finish-register/${orderId}`)
  return (dispatch) => {
    dispatch({ type: FINISH_ORDER_REGISTER, payload: { finishing: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: FINISH_ORDER_REGISTER, payload: { finished: true, data: response.data.data } })
      if (response.data.data?.estado === ORDER_STATUS.FOR_INVOICE) {
        window.open(`${urlPdfs.pedidoTicket}/${orderId}`)
      }
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(FINISH_ORDER_REGISTER, error)
    }).finally(() => {
      dispatch({ type: FINISH_ORDER_REGISTER, payload: { finishing: false } })
    })
  }
}

export function finishOrderWithSeriesAction(orderId) {
  const request = api.post(`/order/finish-with-series/${orderId}`)
  return (dispatch) => {
    dispatch({ type: FINISH_ORDER_WITH_SERIES, payload: { finishing_id: orderId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: FINISH_ORDER_WITH_SERIES, payload: { finished_id: orderId, data: response.data.data } })
      window.open(`${urlPdfs.pedidoTicket}/${orderId}`)
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(FINISH_ORDER_WITH_SERIES, error)
    }).finally(() => {
      dispatch({ type: FINISH_ORDER_WITH_SERIES, payload: { finishing_id: orderId } })
    })
  }
}

export function voidOrderAction(orderId) {
  const request = api.delete(`/order/void/${orderId}`)
  return (dispatch) => {
    dispatch({ type: VOID_ORDER, payload: { voiding_id: orderId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_ORDER, payload: { voided_id: orderId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_ORDER, error)
    }).finally(() => {
      dispatch({ type: VOID_ORDER, payload: { voiding_id: orderId } })
    })
  }
}

export function saveOrderFromProformaAction(proformaId) {
  const request = api.post(`/order/save-from-proforma/${proformaId}`)
  return (dispatch) => {
    dispatch({ type: SAVE_ORDER_FROM_PROFORMA, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_ORDER_FROM_PROFORMA, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_ORDER_FROM_PROFORMA, error)
    }).finally(() => {
      dispatch({ type: SAVE_ORDER_FROM_PROFORMA, payload: { saving: false } })
    })
  }
}

export function sendOrderToEmailAction({ orderId, to }) {
  const request = api.post(`/order/send-order-to-email`, { orderId, to })
  return () => {
    toast.info(`Enviando comprobante a ${to}...`, { toastId: 'sendOrderToEmail', autoClose: false })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message, { toastId: 'sendOrderToEmail' })
        return
      }
      toast.success(response.data.message, { toastId: 'sendOrderToEmail' })
    }).catch((error) => {
      toast.error(error.response?.data?.message ?? 'No se pudo enviar el comprobante', { toastId: 'sendOrderToEmail' })
      console.log(error)
    }).finally(() => {
      toast.update('sendOrderToEmail', { autoClose: 3000 })
    })
  }
}